import { Pen } from "@phosphor-icons/react";
import { useState } from "react";
import PopUp from "../utils/PopUp";
import { toast } from "sonner";
import axios from "axios";

const AdminUserCard = ({ cb }) => {
  const [isVisible, setIsVisible] = useState(false);
  const onClose = () => {
    setIsVisible(false);
  };
  const handleEdit = () => {
    setIsVisible(true);
  };
  return (
    <div>
      <HandleForm
        emailUser={cb.user.email}
        onClose={onClose}
        isVisible={isVisible}
        active={cb.user.status}
        id={cb.user.id}
      />
      <div className="flex justify-end">
        <div
          onClick={handleEdit}
          className="w-12 cursor-pointer text-yellow-500 h-6 relative right-0 shadow  bg-slate-50 rounded-t-lg flex justify-center items-center"
        >
          <Pen weight="fill" />
          <div className="absolute w-full bg-red- h-1 -mb-0.5 z-[1] bg-slate-50 bottom-0"></div>
        </div>
      </div>
      <div className="p-2 relative rounded-lg rounded-se-none shadow flex flex-col gap-2 bg-slate-50">
        {cb.user.name && (
          <div className="flex border-b border-gray-400 justify-between">
            <p className="text-md  font-semibold">{cb.user.name}</p>
            <p className="text-md  font-semibold">{cb.user.bagian}</p>
          </div>
        )}
        <div className="flex gap-2">
          <div
            className={`
          ${
            cb.user.status === 1
              ? "bg-green-700 text-white"
              : "bg-gray-300 text-gray-500"
          }
          px-6 my-1.5  justify-center items-center flex flex-col rounded-lg gap-3`}
          >
            <p className={"text-2xl font-bold "}>{cb.user.id}</p>
          </div>
          {/* BUILD TIME STATUS */}
          <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
            <div className="flex gap-1.5 justify-around px-2 items-center">
              <p className="font-semibold whitespace-nowrap text-xs">
                {cb.user.no_tel}
              </p>
              <p className="font-semibold whitespace-nowrap text-xs">
                {cb.user.posisi}
              </p>
            </div>
            <div className="grid grid-cols-3 ">
              <div className="  flex flex-col gap-0.5 items-center justify-center">
                <p className="text-md font-semibold">{cb.attend}</p>
                <p className="text-xs font-normal text-gray-400">Attend</p>
              </div>
              {/* <div className="border-s border-gray-400 h-full"></div> */}
              <div className=" border-x border-gray-400  flex flex-col gap-0.5 items-center justify-center ">
                <p className="text-md font-semibold">{cb.permission}</p>
                <p className="text-xs font-normal text-gray-400">Leave</p>
              </div>
              {/* <div className="border-s border-gray-400 h-full"></div> */}
              <div className="flex flex-col gap-0.5 items-center justify-center">
                <p className="text-md font-semibold">{cb.sick}</p>
                <p className="text-xs font-normal text-gray-400">Sick</p>
              </div>
            </div>
            <div className="flex gap-1.5 justify-center px-2 items-center">
              <p className="font-semibold whitespace-nowrap text-xs">
                {cb.user.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUserCard;

const HandleForm = ({ emailUser, id, active, isVisible, onClose }) => {
  const [email, setEmail] = useState(emailUser);
  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };
  const handleSubmit = async () => {
    try {
      const update = await axios.put(
        `${process.env.REACT_APP_SERVER}/api/admin/change-email`,
        {
          id,
          email,
        }
      );

      toast.success("Update data is success");
      window.location.reload();
    } catch (e) {
      console.error(e);
      toast.error("Sorry, update data is not success");
    }
  };
  const handleActiveUser = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_SERVER}/api/admin/change-active`,
        {
          id,
          active,
        }
      );

      toast.success("Update data is success");
      window.location.reload();
    } catch (e) {
      console.error(e);
      toast.error("Sorry, update data is not success");
    }
  };
  return (
    <PopUp isVisible={isVisible} onClose={onClose} title={"Edit Data User"}>
      <input
        type="email"
        value={email}
        onChange={handleChange}
        placeholder="email"
        className="input mt-4 input-bordered w-full"
      />
      <div className="flex justify-between px-2 w-full mt-4">
        <button onClick={handleActiveUser} className="btn btn-outline btn-xs">
          {active !== 1 ? "Aktifkan" : "Nonaktifkan"}
        </button>
        <button
          onClick={handleSubmit}
          className="btn text-white bg-green-700  btn-success btn-xs"
        >
          Change Email
        </button>
      </div>
    </PopUp>
  );
};
